// extracted by mini-css-extract-plugin
export default {"physiotherapy":"y","dietetics":"z","occupationalTherapy":"A","speechTherapy":"B","medicine":"C","psychology":"D","tobaccology":"E","sportCoaching":"F","other":"G"};